import { Card } from "../../../components/card";
import React from "react";

type EGiftCardSummaryCardProps = {
    icon: React.ReactNode;
    title: string;
    value: string | number;
};

const EGiftCardSummaryCard = ({
    icon,
    title,
    value
}: EGiftCardSummaryCardProps) => {
    return (
        <Card
            className="flex justify-between items-start p-3 rounded-lg shadow-sm border border-gray-200 bg-white dark:bg-[#212936] dark:border-[#394150]"
        >
            <div>
                <span className="block dark:text-gray-100">{title}</span>
                <span className="block text-2xl font-semibold dark:text-gray-100">{value}</span>
            </div>
            <div className="flex items-start">
                {icon}
            </div>
        </Card>
    );
}

export default EGiftCardSummaryCard;
